import { cr_api, makeApiRequest } from './_init'

export const fetchRecommendedEventsForCustomer = async (customerId) => {
  const result = await makeApiRequest(
    cr_api,
    'post',
    `/events/event_recommendations?customer_id=${customerId}`,
  )

  if (result.error) {
    return {
      success: false,
      data: null,
      error: result.error?.message ?? result.error,
    }
  }

  return {
    success: true,
    data: result.data,
  }
}